import { cloneCustomerServiceFormData } from './customerServiceFormStateHelpers';

export const buildSatisfiedConditionChanges = (condition, checked, currentDate) => ({
    is_satisfied: checked,
    occurred_at: checked && condition.require_date
        ? (condition.occurred_at || currentDate)
        : null,
});

export const buildConditionValues = (mappings = [], savedValues = []) => {
    const savedValueMap = new Map(
        savedValues.map(row => [
            Number(row.service_condition_id),
            row,
        ])
    );

    return mappings.map(mapping => {
        const condition = mapping.service_condition || mapping;
        const serviceConditionId = Number(mapping.service_condition_id || condition.service_condition_id || condition.id);
        const saved = savedValueMap.get(serviceConditionId) || {};

        return {
            service_condition_id: serviceConditionId,
            code: condition.code || saved.code || '',
            name: condition.name || saved.name || '',
            description: condition.description ?? saved.description ?? null,
            input_type: condition.input_type || saved.input_type || 'boolean',
            require_date: !!(condition.require_date ?? saved.require_date),
            required: !!(mapping.required ?? saved.required),
            config: cloneCustomerServiceFormData(mapping.config || saved.config || {}),
            is_satisfied: !!saved.is_satisfied,
            value_number: saved.value_number ?? saved.metadata?.value_number ?? null,
            occurred_at: saved.occurred_at ? String(saved.occurred_at).slice(0, 10) : null,
            note: saved.note || null,
            metadata: cloneCustomerServiceFormData(saved.metadata || null),
            source_type: saved.source_type || mapping.source_type || 'MANUAL',
            read_only: !!(saved.read_only ?? mapping.read_only),
            evidence_count: Number(saved.evidence_count ?? mapping.evidence_count) || 0,
            image_mappings: cloneCustomerServiceFormData(saved.image_mappings || mapping.image_mappings || []),
        };
    });
};
